import allTypes from "./mutation-types"
import publicMutations from "../publicModule/publicMutations"

export default {
  ...publicMutations.call(this, allTypes)
}
